import { styled } from '@mui/material/styles';

export const BetaLabel = styled('div', { label: 'BetaLabel' })(({ theme }) => ({
  backgroundColor: theme.palette.warning.main,
  color: theme.palette.warning.contrastText,
  fontSize: theme.typography.pxToRem(13),
  fontWeight: theme.typography.fontWeightRegular,
  lineHeight: theme.typography.pxToRem(18),
  padding: theme.spacing(0, 1),
  borderRadius: theme.shape.borderRadius,
  textTransform: 'none',
}));
